import { ApiError } from "./api.ts";

/**
 * What to show when a call fails.
 *
 * The API's own message is preferred — a 403 from the database names the rule
 * that refused, which is more useful than "something went wrong". Anything
 * else, including an `ApiError` whose message is blank, gets the screen's own
 * sentence, which is copy and so arrives from the caller's constants file.
 *
 * Lifted from the collection, work record and viewing rooms models, which held
 * byte-identical copies; each keeps a one-line `describeError` so its
 * controllers and tests read as before.
 */
export function describeApiError(cause: unknown, fallback: string): string {
  if (cause instanceof ApiError) {
    return cause.message.trim() === "" ? fallback : cause.message;
  }
  return fallback;
}
